<template>
  <div class="row mb-3">
    <div class="col-12 d-flex gap-2">
      <input
          type="text"
          class="form-control"
          :placeholder="placeholder"
          v-model="localSearch"
          @input="onInputChange"
      />
      <button
          v-if="localSearch"
          class="btn btn-outline-secondary"
          @click="clearSearch"
          title="Zoekopdracht wissen"
      >
        ✖
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SearchOrder',

  props: {
    searchQuery: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Zoeken',
    },
  },

  emits: ['performSearch'],

  data() {
    return {
      localSearch: this.searchQuery,
    }
  },

  watch: {
    searchQuery(newVal) {
      this.localSearch = newVal
    }
  },

  created() {
  },

  methods: {
    onInputChange() {
      this.$emit('performSearch', this.localSearch.trim());
    },
    clearSearch() {
      this.localSearch = ''
      this.$emit('performSearch', '')
    },
  },
}
</script>

<style scoped>
button.btn {
  white-space: nowrap;
}
</style>